<template lang="pug">
    v-layout(row wrap)
        v-flex.pl-5.px-5.pt-3.mySelectorContract(md12)
            v-autocomplete.pl-5.px-5(
                v-model="contractStructureType" 
                :items="arrContractsProp"
                item-text ='text'
                item-value ='id'
            )
                div.formLabel(slot="prepend") Contratos Inactivos
        crud-form( 
            v-bind="formProps" 
            :fields="fields" 
            @submitForm="submitContractForm" 
            @reset="resetForm"
            ref="validateContractForm" 
            )
        
</template>

<script>
/* components */
import {CrudForm} from '@/components/reusable_components'
import contractFields from './fields/EmployeeContractFields' 
/* Services */
import ContractService from '@/services/api/contract'
import EmployeeService from '@/services/api/employee'
import ContractTypeService from '@/services/api/contractType'
import ContractPeriodService from '@/services/api/contractPeriod'
import ContractStructureService from '@/services/api/contractStructure'
/* vuex */
import {mapActions, mapState} from 'vuex'
export default {
    name: 'employee-all-contract',
    props: {
        arrContractsProp:{
            type:Array,
            default:()=>[],
        }
    },
    data: function(){
        return {
            fields: contractFields,
            employeeContract:{},
            contractStructureType: null,
            arrContractStructureType: [],
            formIsEditable : false,
            contractData : null,
            contractId : null,
        }
    },
    computed: {
        /**
         * 
         */
        formProps(){
            return{
                submitText: 'Activar Contrato'
            }
        },
        /**
         * 
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        /**
         * 
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        /**
         * 
         */
        async fetchAllEmployees(){
            return await EmployeeService.fetchAll()
        },
        async setEmployees(){
            let arrEmployees = await this.fetchAllEmployees()
            this.fields[0].options.data = this.formatNameEmployee(arrEmployees)
        },
        /** 
         * 
         */
        formatNameEmployee(arrEmployee){
            return arrEmployee.map(employee=>{
                let newEmployee = {...employee}
                newEmployee.nameComplete = `${employee.names} ${employee.last_name1} ${employee.last_name2}`
                return newEmployee
            })
        },
        /**
         * 
         */
        async fetchAllContractType(){
            return await ContractTypeService.fetchAll()
        },
        /**
         * 
         */
        async setContractType(){
            let arrContractType = await this.fetchAllContractType()
            this.fields[1].options.data = arrContractType.data
        },
        /**
         * 
         */
        async fetchAllContractPeriod(){
            return await ContractPeriodService.fetchAll()
        },
        /**
         * 
         */
        async setContractPeriod(){
            let arrContractPeriod = await this.fetchAllContractPeriod()
            this.fields[2].options.data = arrContractPeriod.data
        },
        /**
         * 
         */
        async fetchContractStructureType(){
            let response = await ContractStructureService.fetchAll()
            return response
        },
        /**
         * 
         */
        setStructureInsideForm(idStructureContract){
            //
            const structureContracts = [...this.arrContractsProp]
            let contract = structureContracts.find( contract => contract.id === idStructureContract )
            if ( contract )
                this.setParamsStructureForm( contract )
        },
        /**
         * 
         */
        setParamsStructureForm(contract){
            let setFields = [...this.fields]
            setFields[0].value = contract.hr_employee_id
            setFields[1].value = contract.hr_contract_type_id
            setFields[2].value = contract.hr_contract_period_id
            setFields[3].value = contract.weekly_hours
            setFields[4].value = contract.base_salary
            setFields[5].value = contract.collation
            setFields[6].value = contract.mobilization
            setFields[7].value = contract.init_date
            setFields[8].value = contract.end_date
            setFields[9].value = contract.vacations_since
            setFields[10].value = contract.vacations_progressive_days
            this.fields = [...setFields]
        },
        
        resetForm(){
            this.$refs.validateContractForm.$refs.form.reset()
        },
        /**
         * 
         */
        submitContractForm(event){
            this.setContractData(event)
            this.confirmCreateContract()
        },
        /**
         * 
         */
        setContractData(contractData){
            this.contractData = contractData
        },
        /** 
         * 
         */
        confirmCreateContract(){
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Activar')
            this.initSnackbar(this.fillSnack('warning','Activación Contrato','¿Desea activar el contrato?'))

        },
        /**
         * 
         */
        async activateContract(){
            if ( this.contractData ) {
                const contractId = this.getContractId()
                let response = await ContractService.activateContract( contractId )
                this.snackResponseSubmit( response )
            }
        },
        /**
         * 
         */
        snackResponseSubmit(response){
            if ( response.status ==='success' ){
                const msg = 'Contrato Activado exitosamente'
                this.successMessage(msg)
                this.redirectTo('/employees')
                this.$emit('closeDialogContract')
            }
            else
                this.errorMessage(response)
            
        },
        /**
         * 
         */
        successMessage(message){
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack('success','Éxito',message,false,5000))
        },
        /**
         * 
         */
        errorMessage(response){
            this.resetSnackbarState()
            if(response.message)
                this.initSnackbar(this.fillSnack('error','Error',response.message,false,5000))
            else
                this.initSnackbar(this.fillSnack('error','Error','Ha ocurrido un error al enviar los datos al servidor',false,5000))
        },
        /**
         * 
         */
        redirectTo(route){
            this.$router.push(route)
        },
        /**
         * 
         */
        setContractId(contractId){
            this.contractId = contractId
        },
        /**
         * 
         */
        getContractId(){
            return this.contractId 
        },
        /**
         * 
         */
        resetSelectorContracts(){
            this.contractStructureType = null
        },
        /**
         * 
         */
        showWaitingResponse(){
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack('info','Activando contrato','espere por favor',true))
        },
        /**
         * 
         */
        resetForm(){
            this.$refs.validateContractForm.$refs.form.reset()
        }
       
    },
    watch: {
        contractStructureType (idContractStructure){
            if(idContractStructure !=null){
                this.setStructureInsideForm(idContractStructure)
                this.setContractId(idContractStructure)
            }
        },
        /**
         * 
         */
        responseConfirm(val){
            switch (val) {
                case 'Activar':
                    this.resetSnackbarState()
                    this.showWaitingResponse()
                    this.activateContract()
                    break;
            
                default:
                    break;
            }
        },
        
    },
    components: {
        'crud-form':CrudForm,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function(){
        // this.setTitleTopBar('Edición contrato')
        this.setContractId()
        this.setEmployees()
        this.setContractType()
        this.setContractPeriod()
        
    },
    mounted: function(){
        this.resetForm()
    },
    // beforeUpdate: function(){...},
    //updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    .spanStatus{
        color :red;
        font-weight: bold;
        font-size:20px;
    }
</style>